import get from 'lodash/get';

/**
 * Creates selector to pull state from the given redux state key/reducer key.
 * @param  {string}   key
 * @return {Function}
 */
export const getStateFromKeySelector = key => state => get(state, key, null);
